<!-- 本日の測定履歴画面 -->

<template>
  <div class="whole-wrap whole-wrap--gray">
    <BurgerMenuComponent :isGradation="false" />

    <div class="measure-history">
      <!--
      <div class="btn btn-back ml-16" @click="goBack">戻る</div>
      <div class="measure-history-title">測定履歴</div>
      -->

      <!-- 新規追加 -->
      <div class="measure-history-top">
        <div class="top-title">
          <!-- <div class="top-title-back" @click="isOpenSerche ? closeSerche : goBack"> -->
          <div v-if="isOpenSerche == false" class="top-title-back" @click="goBack">
            <div class="top-title-back-icon"></div>
              {{ $t('history.back') }}
          </div>
          <div v-if="isOpenSerche == true" class="top-title-back" @click="closeSerche">
            <div class="top-title-back-icon"></div>
              {{ $t('history.back') }}
          </div>

          <div class="top-title-text">{{ $t('history.title') }}</div>
        </div>

        <div class="top-select mt-20">
          <!-- 日付選択 --><!-- vue3-datepickerを使用？-->
          <!-- <div v-if="isOpenSerche == false" class="top-select-calendar">
            2024年12月10日
            <div class="top-select-calendar-icon"></div>
          </div> -->
          <select 
            v-if="isOpenSerche == false"
            v-model="selectedDate"
            class="top-select-calendar"
          >
            <option
              v-for="(option) in dateOptions"
              :key="option.value"
              :value="option.value"
            >
            {{ option.title }}
            </option>
        
          </select>

          <!-- 検索フォーム：Close -->
          <div v-if="isOpenSerche == false" class="top-select-serche top-select-serche--close" @click="openSerche">
            <div class="top-select-icon"></div>
            <span class="ml-11 en-ml-6">{{ $t('history.search_by_id') }}</span>
          </div>

          <!-- 検索フォーム：Open -->
          <div v-if="isOpenSerche == true" class="top-select-serche top-select-serche--open" >
            <input
            type="text" class="isopne-serche-text" id="serche_key" name="serche_key"
            v-model="searchQuery"
            :placeholder="$t('history.enter_subject_id')"
            @keyup.enter="serches"
          >
            <div class="isopne-serche-icons">
              <div class="icon-close" @click="clearSerche"></div>
              <div class="icon-separator"></div>
              <div class="top-select-icon"></div>
              <div class="top-select-area" @click="serches"></div>
            </div>

          </div>
        </div>
      </div>
      <!-- ---- -->

      <div class="measure-history-list">
        <div class="measure-history-item">
          <div class="measure-history-item-inner" v-for="item in measureHistoryList" :key="item.id">
            <div v-if="isOpenSerche == false" class="measure-histor-item-time">{{ inspectionTime(item.inspection_end_time) }}</div>
            <div v-if="isOpenSerche == false" class="measure-histor-item-id">{{ item.subject_id }}</div>
            <div v-if="isOpenSerche == true" class="measure-histor-item-time-full">{{ inspectionTimeFull(item.inspection_end_time) }}</div>
            <div class="measure-histor-item-gender">{{ getGenderText(item.gender) }}</div>
            <div class="measure-histor-item-age">{{ item.age==="000"?$t('history.age_not_entered'):item.age}}{{$t('history.years_old_suffix')}}</div>
            <div class="btn measure-histor-item-preview" :class="{ 'disabled-report': !item.report_inspection_id }" @click="item.report_inspection_id && previewReport(item.report_inspection_id)"></div>
          </div>
        </div>
      </div>
      <div v-if="measureHistoryList.length == 0" class="measure-history-message">{{ message }}</div>
    </div>
    <!-- コピーライト -->
    <div class="text-copyright">© 2025 Lion Corporation. All rights reserved.</div>
  </div>
</template>
  
<script>
import { ref, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { formatDate, formatDate2, formatTime, } from './common/dateFormatter';
import BurgerMenuComponent from './BurgerMenu.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { i18nConfig } from '@/i18n';

export default {
  components: {
    BurgerMenuComponent,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const $toast = useToast();

    const operatorId = ref(store.getters['dataManagement/getOperatorId']);
    const measureHistoryList = ref([]);
    const isOpenSerche = ref(false);
    const searchQuery = ref('');

    const dateOptions = ref([]);
    const selectedDate = ref(formatDate2(new Date()));
    const message = ref('');
    
    // const jsonData = ref(null);

    // ページがマウントされたときにデータを取得する
    onMounted(async () => {
      await createDateOptions();
//      await getHistory();
    });

    const createDateOptions = async () => {
      try {
        // 測定履歴の取得
        const dateResult = await store.dispatch('measureHistory/targetDates', operatorId.value);

        // 取得結果が成功の場合、データを更新
        if (dateResult.success) {
          dateOptions.value = dateResult.result.map(i => {
            const [year, month, day] = i.split("-");

            if (i18nConfig.locale === 'ja') {
              return {title: `${year}年${month}月${day}日`, value: i};
            } else {
              return {title: `${month}/${day}/${year}`, value: i};
            }
          });

          if (dateOptions.value.length == 0) message.value = t('history.no_records');
          else {
            selectedDate.value = dateOptions.value[0].value;
            await getHistory(selectedDate.value);
          }
        } else {
          throw new Error(dateResult.error);
        }
      } catch (error) {
        // エラーが発生した場合、エラーメッセージを表示
        console.error('対象日の取得中にエラーが発生しました:', error);
        $toast.error(error.message, { duration: 5000 });
      }
    }

    watch(selectedDate, async () => {
      await getHistory(selectedDate.value);
    })

    // 検索フォーム開く
    const openSerche = () => {
      isOpenSerche.value = true;
      measureHistoryList.value = [];
      message.value = t('history.search_instruction');
    }

    // 検索フォーム閉じる
    const closeSerche = async () => {
      isOpenSerche.value = false;
      searchQuery.value = ""; // searchQuery初期化
      await getHistory(selectedDate.value);
    }

    const clearSerche = () => {
      searchQuery.value = ""; // searchQuery初期化
      measureHistoryList.value = [];
      message.value = t('history.search_instruction');
    }

    // 検索処理
    const serches = async () =>{
      if (searchQuery.value) {
        await getHistory(null, searchQuery.value);
      } else {
        measureHistoryList.value = [];
      }
    }

    // 測定履歴データを取得する関数
    const getHistory = async (date, subjectId) => {
      try {
        // 測定履歴の取得
        const historyResult = await store.dispatch('measureHistory/select', {operator_id: operatorId.value, target_date: date, subject_id: subjectId});

        // 取得結果が成功の場合、データを更新
        if (historyResult.success) {
          measureHistoryList.value = historyResult.result;
          if (measureHistoryList.value.length == 0) message.value = t('history.no_records');
        } else {
          throw new Error(historyResult.error);
        }
      } catch (error) {
        // エラーが発生した場合、エラーメッセージを表示
        console.error('測定履歴の取得中にエラーが発生しました:', error);
        $toast.error(error.message, { duration: 5000 });
      }
    };

    // 性別コードからテキストに変換する関数
    const getGenderText = (gender) => {
      switch (gender) {
        case 1:
          return t('subject.sex_male');
        case 2:
          return t('subject.sex_female');
        case 3:
          return t('subject.sex_other');
        default:
          return t('history.age_not_entered');
      }
    };

    // 日時をフォーマットする関数
    const inspectionTime = (dateTime) => {
      // DBから取得した Date オブジェクトを変換
      const date = new Date(dateTime);
      // 日本標準時の時差9時間を考慮
      const japanTimeOffset = 9 * 60 * 60 * 1000;
      // ローカル時刻に変換
      const localDate = new Date(date.getTime() - japanTimeOffset);

      return formatTime(localDate);
    };
    const inspectionTimeFull = (dateTime) => {
      // DBから取得した Date オブジェクトを変換
      const date = new Date(dateTime);
      // 日本標準時の時差9時間を考慮
      const japanTimeOffset = 9 * 60 * 60 * 1000;
      // ローカル時刻に変換
      const localDate = new Date(date.getTime() - japanTimeOffset);

      return formatDate(localDate) + '　' + formatTime(localDate);
    };

    function isAllValuesString(data) {
      for (const key in data) {
          const value = data[key];
        if (typeof value === "object" && value !== null) {
          // オブジェクトや配列の場合は再帰的に確認
          if (!isAllValuesString(value)) {
              return false; // ネストされたオブジェクトで文字列以外が見つかった場合
          }
        } else if (typeof value !== "string") {
          // 文字列以外の値が見つかった場合
          return false;
        }
      }
      return true; // 全ての値が文字列の場合
    }

    // レポートを表示する関数
    const previewReport = async (id) => {
      const reportData = await store.dispatch('measureHistory/getReportData', id);
      const of5Data = await store.dispatch('measureHistory/getOf5Data', id);
      const parsedReportData = ref();

      if(isAllValuesString(reportData)){
        parsedReportData.value = JSON.parse(reportData);
      }else {
        parsedReportData.value = reportData;
      }

      // レポートストアのクリア
      await store.dispatch('dataManagement/clearReport');
      await store.dispatch('dataManagement/setResultReportData', parsedReportData);
      await store.dispatch('dataManagement/setResultOf5Data', of5Data);

      await router.push({
        name: 'result',
        params: {operator_id: operatorId.value},
      });
    }

    // 戻るボタンが押されたときの処理
    const goBack = () => {
      router.go(-1);
    };



    return {
      measureHistoryList,
      isOpenSerche,
      getGenderText,
      inspectionTime,
      inspectionTimeFull,
      previewReport,
      goBack,
      openSerche,
      closeSerche,
      clearSerche,
      searchQuery,
      serches,
      dateOptions,
      selectedDate,
      message,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

.measure-history-item-inner {
  margin-left: 5px;
  margin-right: 25px;
  align-items: center;
  word-wrap: break-word;
}

.measure-history-list {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
}

.measure-history-message {
    max-width: 450px;
    margin: 0 auto;    
    padding: 24px 88px;
    font-size: 14px;
    text-align: center;
    color: #575757;
    background-color: #f7f9fc;
  }

.measure-histor-item-id {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.disabled-report {
  opacity: 0.2;
  cursor: not-allowed;
}
</style>